var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table table-striped limit table-responsive-xl" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.users, function (user) {
          return _c("tr", [
            _c("td", [_vm._v("\n\t\t\t" + _vm._s(user.id) + "\n\t\t")]),
            _vm._v(" "),
            _c("td", [_vm._v("\n\t\t\t" + _vm._s(user.user_name) + "\n\t\t")]),
            _vm._v(" "),
            _c("td", [_vm._v("\n\t\t\t" + _vm._s(user.pass) + "\n\t\t")]),
            _vm._v(" "),
            _c("td", [_vm._v("\n\t\t\t" + _vm._s(user.userright) + "\n\t\t")]),
            _vm._v(" "),
            _c("td", [
              _c("i", {
                staticClass: "fal fa-edit edit_exchange_user",
                on: {
                  click: function ($event) {
                    return _vm.edit_user(user)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("th", [
              _c("i", {
                staticClass: "fa fa-times remove_exchange_user",
                on: {
                  click: function ($event) {
                    return _vm.remove_user(user)
                  },
                },
              }),
            ]),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("th", { attrs: { width: "20" } }, [_vm._v("ID")]),
      _vm._v(" "),
      _c("th", [_vm._v("Логiн")]),
      _vm._v(" "),
      _c("th", [_vm._v("Пароль")]),
      _vm._v(" "),
      _c("th", { attrs: { width: "40" } }, [_vm._v("Права")]),
      _vm._v(" "),
      _c("th", { attrs: { width: "10" } }),
      _vm._v(" "),
      _c("th", { attrs: { width: "10" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }